import React from "react";
import { Image } from "react-bootstrap";
import user from "../../../images/user.webp";
import cv from "../../../cvFile/shmagigavashelashvili.cv.pdf";
import { Container } from "react-bootstrap";
import "./about.scss";

function About() {
  return (
    <section id="about" className="about section">
      <h1>
        About<span>Me</span>
      </h1>
      <Container className="about-container">
        <div className="about-img">
          <Image src={user} alt="shmagi" />
        </div>
        <div className="about-content">
          <h2 className="about-content-title">Software Engineer</h2>
          <p className="about-content-text">
            I am Shmagi, former energy expert and now front end developer. In 2012 graduated from
            Georgian Technical University and worked in the field of energy for 10 years.
          </p>
          <p className="mt-3 about-content-text">
            Since 2020, I have explored a new area of ​​interest - Front End Development
          </p>
          <a href={cv} className="about-content-btn" download>
            Donwnload cv
          </a>
        </div>
      </Container>
      <Container className="mt-5 skills">
        <h2 className="skills-title">
          Tech <span>Skills</span>
        </h2>
        <div className="skills-content">
          <ul className="skills-content-list">
            <li className="skills-content-list-item">html</li>
            <li className="skills-content-list-item">css (Bootstrap, Sass)</li>
            <li className="skills-content-list-item">javascript (React.js, Vue.js, Node.js)</li>
            <li className="skills-content-list-item">Redux, Vuex</li>
            <li className="skills-content-list-item">Typescript</li>
            <li className="skills-content-list-item">Git</li>
          </ul>
        </div>
      </Container>
    </section>
  );
}

export default About;
